import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { FieldType } from '../../models/field-types/field-type';
import { DataType } from '../../types/field-types/data-type';
import { InputType } from '../../types/field-types/input-type';
import { FieldTypeDataProvider } from './field-type-data-provider';

@Injectable({
  providedIn: 'root'
})
export class FieldTypeService {

  private fieldTypeList: FieldType[] = [];
  private providers: { [key: string]: FieldTypeDataProvider } = {};
  private validators: { [key: string]: ValidatorFn } = {};

  constructor() { }

  registerValidatorForFieldType(fieldType: string, fn: ValidatorFn) {
    this.validators[fieldType] = fn;
  }

  registerDataProviderForFieldType(fieldType: string, provider: FieldTypeDataProvider) {
    this.providers[fieldType] = provider;
  }

  providerForFieldType(fieldType: string): FieldTypeDataProvider {
    return this.providers[fieldType];
  }

  validatorForFieldType(fieldType: string): ValidatorFn {
    return this.validators[fieldType];
  }

  fetchFieldTypeConfig(fieldType: string): FieldType | undefined {
    return this.fieldTypes().find(item => item.id === fieldType);
  }

  registerFieldTypes(fieldTypes: FieldType[]) {
    this.fieldTypeList = this.fieldTypeList
      .filter(item => fieldTypes.find(fieldType => fieldType.id === item.id) == null)
      .concat(fieldTypes);
  }

  fieldTypes() {
    return this.fieldTypeList;
  }

  dataTypeForFieldType(fieldType: any): DataType {
    const match = this.fieldTypes().find(item => item.id === fieldType);
    if (match != null) {
      return match.dataType ?? DataType.STRING;
    }
    return DataType.STRING;
  }

  inputTypeForFieldType(fieldType: any): InputType {
    const match = this.fieldTypes().find(item => item.id === fieldType);
    if (match != null) {
      return match.inputType ?? InputType.TEXT;
    }
    return InputType.TEXT;
  }
}
